module.exports = __webpack_public_path__ + "img/pdf-file.afe7e2d4.svg";